import React from 'react';
import clsx from 'clsx';
import { Loader2 } from 'lucide-react';

/** Пустое состояние: иконка, заголовок, пояснение, действие */
export function EmptyState({ icon: Icon, title, text, action, className }) {
  return (
    <div className={clsx('flex flex-col items-center justify-center px-6 py-14 text-center', className)}>
      {Icon && (
        <span className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-zinc-100 text-zinc-500 dark:bg-zinc-800 dark:text-zinc-400">
          <Icon className="h-5 w-5" />
        </span>
      )}
      <p className="text-sm font-semibold text-zinc-900 dark:text-zinc-100">{title}</p>
      {text && <p className="mt-1 max-w-sm text-sm text-zinc-500 dark:text-zinc-400">{text}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function Spinner({ className }) {
  return <Loader2 className={clsx('h-5 w-5 animate-spin text-zinc-400', className)} />;
}

export function Skeleton({ className }) {
  return <div className={clsx('animate-pulse rounded-md bg-zinc-200/70 dark:bg-zinc-800', className)} />;
}

/** Загрузка целой области */
export function LoadingBlock({ className }) {
  return (
    <div className={clsx('flex items-center justify-center py-16', className)}>
      <Spinner />
    </div>
  );
}
